import React, { useEffect, useRef, useState } from "react";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Tab,
  Tabs,
  TextField,
} from "@material-ui/core";
import Datetime from "react-datetime";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { CommonConfig } from "CommonConfig";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { Button } from "primereact/button";
import moment from "moment";
import { Autocomplete, ButtonGroup } from "@mui/material";
import APIConstant from "utils/constant";
import api from "utils/api";
import { MultiSelect } from "primereact/multiselect";
import MenuItem from "@material-ui/core/MenuItem";
import _ from "lodash";
import cogoToast from "cogo-toast";
import { Dropdown } from "primereact/dropdown";
import Loader from "components/Shared/Loader/Loader";

const initialNameState = {
  name: "",
  error: false,
  errorText: "",
};

const initialNameArrayState = {
  name: [],
  error: false,
  errorText: "",
};

const AddInwardStock = (props) => {
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [userId, setUserId] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const [OutwardTabValue, setOutwardTabValue] = useState(0);
  const [stockId, setStockId] = useState("");
  const [multiplyProcessDialog, setMultiplyProcessDialog] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [inwardNumber, setInwardNumber] = useState(initialNameState);
  const [outwardTo, setOutwardTo] = useState(initialNameState);
  const [outwardToData, setOutwardToData] = useState(initialNameState);
  const [invoiceNumber, setInvoiceNumber] = useState(initialNameState);
  const [process, setProcess] = useState(initialNameArrayState);
  const [vendor, setVendor] = useState(initialNameState);
  const [order, setOrder] = useState("");
  const [subWareHouse, setSubWareHouse] = useState(initialNameState);
  const [dateTime, setDateTime] = useState(new Date());
  const [processList, setProcessList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [subWareHouseList, setSubWareHouseList] = useState([]);
  const [equipmentList, setEquipmentList] = useState([]);

  const [remark, setRemark] = useState("");
  const [isApplyToAll, setIsApplyToAll] = useState(true);
  const [isApplySubWareHouseToAll, setIsApplySubWareHouseToAll] = useState(
    true,
  );
  const [isApplyOutwardToAll, setIsApplyIsApplyOutwardToAll] = useState(true);
  const [itemList, setItemList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [item, setItem] = useState(initialNameState);
  const [gstList, setGstList] = useState([]);
  const [unit, setUnit] = useState(initialNameState);
  const [qty, setQty] = useState(initialNameState);
  const [cost, setCost] = useState(initialNameState);
  const [discount, setDiscount] = useState(initialNameState);
  const [gst, setGst] = useState(initialNameState);
  const [vendorData, setVendorData] = useState(initialNameState);
  const [subWarehouseData, setSubWarehouseData] = useState(initialNameState);
  const [addDataDialog, setAddDataDialog] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [editRawDataList, setEditRawDataList] = useState([]);
  const [rawDataList, setRawDataList] = useState([]);
  const [convertedDataList, setConvertedDataList] = useState([]);
  const [tempProcessMultiplyList, setTempProcessMultiplyList] = useState([]);
  const [processMultiplyList, setProcessMultiplyList] = useState([]);
  const [itemStocks, setItemStocks] = useState([]);
  const [outwardMode, setOutwardMode] = useState("Self");
  const [selfWardMode, setSelfWardMode] = useState("");
  const [loading, setLoading] = useState(false);
  const [configurationList, setConfigurationList] = useState([
    { label: "Sell", value: "Sell" },
    { label: "Self", value: "Self" },
  ]);
  const [selfModeOptions, setSelfModeOptions] = useState([
    { label: "Lifo", value: "Lifo" },
    { label: "Fifo", value: "Fifo" },
    { label: "Average", value: "Average" },
  ]);
  const [configurationId, setConfigurationId] = useState("");

  // Add Vendor Modal States
  const [addVendorModal, setAddVendorModal] = useState(false);
  const [vendorFirstName, setVendorFirstName] = useState("");
  const [vendorLastName, setVendorLastName] = useState("");
  const [vendorCompanyName, setVendorCompanyName] = useState("");
  const [vendorPhone, setVendorPhone] = useState("");
  const [vendorEmail, setVendorEmail] = useState("");
  const [vendorAddress, setVendorAddress] = useState("");
  const [vendorUserType, setVendorUserType] = useState([]);
  const [vendorUserTypeList, setVendorUserTypeList] = useState([]);

  const multiSelectRef = useRef(null);

  useEffect(() => {
    if (rawDataList.length === 0 && !readOnly) {
      addBlankRow();
    }
  }, []);

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");

    // if (lockstatus == 0) {
    if (token !== null) {
      setUserId(data);
      setUserPageAccess(userPageAccess);
      getProcessList(data);
      getItemList(data);
      getUnitList(data);
      getSubWareHouseList(data);
      getVendorList(data);
      getClientList(data);
      getEquipmentList(data);
      getGSTList(data);
      getItemStocks(data);
      getGeneralConfiguration(data);
      getVendorUserTypeList(data);

      if (props?.location?.state) {
        let newState = props.location.state;
        // Forced tabValue 0
        setTabValue(0);
        if (newState.type === "Add" || !newState.type) {
          generateStockNo(data, 0);
          GetOrderList(data);
        } else if (newState.type === "View") {
          setReadOnly(true);
          setStockId(newState.stockId);
          getStockById(newState.stockId, data, 0);
        } else if (newState.type === "Edit") {
          setStockId(newState.stockId);
          getStockById(newState.stockId, data, 0);
        }
      }
    } else {
      props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  }, []);

  const getProcessList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetProcessMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          setProcessList(
            response.Data.map((data) => ({
              ...data,
              label: data.ProcessName,
              value: data._id,
            })),
          );
        }
      })
      .catch((err) => { });
  };

  const GetOrderList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetOrderItems, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setOrderList(
            filterArry.map((item) => ({
              ...item,
              label: item.OrderNumber,
              value: item._id,
            })),
          );
        }
      })
      .catch((err) => { });
  };

  const getItemList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetItemMasterList, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              ...data,
              label: data.chapter_name,
              value: data.value,
            }),
          );
          setItemList(filterArry);
        }
      })
      .catch((err) => { });
  };

  const getUnitList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetUnitMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;

          setUnitList(filterArry);
        }
      })
      .catch((err) => { });
  };

  const getGSTList = async (UserId) => {
    let params = {
      ID: UserId,
      Type: "GST",
    };
    api
      .post(APIConstant.path.GetMasterListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.name,
              value: data.value,
            }),
          );

          setGstList(filterArry);
        }
      })
      .catch((err) => { });
  };

  const getVendorList = async (UserId) => {
    debugger;
    let params = {
      UserId: UserId,
      UserType: "Vendor",
    };
    api
      .post(APIConstant.path.GetNotVerifiedNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.Name,
              value: data._id,
            }),
          );

          setVendorList(filterArry);
        }
      })
      .catch((err) => {
        console.log("Error in getVendorList", err);
      });
  };

  const getClientList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Client",
    };
    api
      .post(APIConstant.path.GetNotVerifiedNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.Name,
              value: data._id,
            }),
          );

          setClientList(filterArry);
        }
      })
      .catch((err) => { });
  };

  const getVendorUserTypeList = async (UserId) => {
    let params = {
      ID: UserId,
      Type: "NETWORKUSERTYPE",
    };
    api
      .post(APIConstant.path.GetMasterListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          setVendorUserTypeList(
            response.Data.map((data) => ({
              ...data,
              label: data.name,
              value: data._id,
            })),
          );
        }
      })
      .catch((err) => { });
  };

  const resetVendorModal = () => {
    setVendorFirstName("");
    setVendorLastName("");
    setVendorCompanyName("");
    setVendorPhone("");
    setVendorEmail("");
    setVendorAddress("");
    setVendorUserType([]);
    setAddVendorModal(false);
  };

  const addVendorHandler = async () => {
    if (CommonConfig.isEmpty(vendorCompanyName)) {
      cogoToast.error("Please enter Company Name");
      return;
    }
    if (vendorUserType.length <= 0) {
      cogoToast.error("Please select User Type");
      return;
    }
    try {
      Loader.show();
      let params = {
        FirstName: vendorFirstName,
        LastName: vendorLastName,
        CompanyName: vendorCompanyName,
        PhoneNumber: vendorPhone,
        Email: vendorEmail,
        Address: vendorAddress,
        UserId: userId,
        CHAID: userId,
        HandlerImporterMasterID: "",
        Type: vendorUserType,
      };
      let formData = new FormData();
      formData.append("Data", JSON.stringify(params));
      api
        .post(APIConstant.path.AddNonVerifiedNetworkUser, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.Success === 1) {
            cogoToast.success(response.Message);
            resetVendorModal();
            getVendorList(userId);
          } else {
            cogoToast.error(response.Message);
          }
          Loader.hide();
        })
        .catch((err) => {
          cogoToast.error("Something went wrong");
          Loader.hide();
        });
    } catch (e) {
      console.log(e);
      Loader.hide();
    }
  };

  const addStock = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    let from = vendor;
    let fromList = vendorList;
    let to = subWareHouse;
    let toList = subWareHouseList;

    if (tabValue === 1) {
      from = subWareHouse;
      fromList = subWareHouseList;
      to = outwardTo;
      toList = outwardToList;
    }

    let OutwardType = "";
    if (tabValue === 1) {
      if (OutwardTabValue === 0) {
        OutwardType = "Machinery";
      } else if (OutwardTabValue === 1) {
        OutwardType = "Sell";
      } else {
        OutwardType = "Warehouse";
      }
    }
    let params = {
      UserId: userId,
      StockId: stockId,
      Type: tabValue === 0 ? "Inward" : "Outward",
      OutwardType,
      IdNo: inwardNumber.name,
      Order: order,
      Process: processList.filter((data) => process.name.includes(data._id)),
      DateTime: dateTime,
      InvoiceNumber: invoiceNumber.name,
      Remark: remark,
      From: from.name,
      FromName:
        fromList.filter((data) => from.name === data.value)?.[0]?.label || "",
      To: to.name,
      ToName: toList.filter((data) => to.name === data.value)?.[0]?.label || "",
      RawData: rawDataList.map((data) => ({
        ...data,
        FromName:
          fromList.filter(
            (dataFrom) =>
              data[getRawDataLabel().Input1.value] === dataFrom.value,
          )?.[0]?.label || "",
        ToName:
          toList.filter(
            (dataTo) => data[getRawDataLabel().Input2.value] === dataTo.value,
          )?.[0]?.label || "",
      })),
      ConvertedData: convertedDataList.map((data) => ({
        ...data,
        FromName:
          fromList.filter(
            (dataFrom) =>
              data[getRawDataLabel().Input1.value] === dataFrom.value,
          )?.[0]?.label || "",
        ToName:
          toList.filter(
            (dataTo) => data[getRawDataLabel().Input2.value] === dataTo.value,
          )?.[0]?.label || "",
      })),
      MethodType: selfWardMode,
    };
    api
      .post(APIConstant.path.AddUpdateStock, params)
      .then((response) => {
        if (response.Success === 1) {
          cogoToast.success(response.Message);
          props.history.push("/admin/inward-stock");
        } else {
          cogoToast.error(response.Message);
        }
      })
      .catch((err) => { });
  };

  const getStockById = async (StockId, UserId, tab) => {
    let params = {
      UserId: UserId || userId,
      StockId,
    };
    api
      .post(APIConstant.path.GetStockById, params)
      .then(async (response) => {
        if (response.Success === 1) {
          let data = response.Data;
          setInwardNumber({
            name: data.IdNo,
            error: false,
            errorText: "",
          });
          setInvoiceNumber({
            name: data.InvoiceNumber,
            error: false,
            errorText: "",
          });
          setOrder(data.Order || "");
          setDateTime(new Date(data?.DateTime));
          setRemark(data?.Remark);
          setOutwardMode(data?.OutwardMode);
          setOutwardTabValue(
            data?.OutwardType === "Sell"
              ? 1
              : data?.OutwardType === "Machinery"
                ? 0
                : 2,
          );
          setProcess({
            name: data.Process.map((process) => process.ProcessId),
            error: false,
            errorText: "",
          });
          if (tab === 0) {
            setVendor({
              name: data.From,
              error: false,
              errorText: "",
            });
            setSubWareHouse({
              name: data.To,
              error: false,
              errorText: "",
            });
          } else {
            setSubWareHouse({
              name: data.From,
              error: false,
              errorText: "",
            });
            setOutwardTo({
              name: data.To,
              error: false,
              errorText: "",
            });
          }
          setRawDataList(data.RawData);
          setEditRawDataList(_.cloneDeep(data.RawData));
          setConvertedDataList(data.ConvertedData);
        }
      })
      .catch((err) => { });
  };

  const getSubWareHouseList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetSubWareHouseList, params)
      .then((response) => {
        if (response.Success === 1) {
          setSubWareHouseList(
            response.Data.map((subWareHouse) => ({
              label: subWareHouse.Name,
              value: subWareHouse._id,
            })),
          );
        }
      })
      .catch((err) => { });
  };

  const getEquipmentList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetEquipmentMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          setEquipmentList(
            response.Data.map((equipment) => ({
              label: equipment.EquipmentName,
              value: equipment._id,
            })),
          );
        }
      })
      .catch((err) => { });
  };

  const generateStockNo = async (UserId, tabVal) => {
    let params = {
      UserId: UserId || userId,
      Type: tabVal === 0 ? "I" : "O",
    };
    api
      .post(APIConstant.path.GenerateUniqueStockNo, params)
      .then((response) => {
        if (response.Success === 1) {
          setInwardNumber({
            name: response.generatedID,
            error: false,
            errorText: "",
          });
        }
      })
      .catch((err) => { });
  };

  const checkUnitConversion = async (data) => {
    try {
      const response = await api.post(
        APIConstant.path.CheckUnitConversion,
        data,
      );
      return response;
    } catch (err) {
      console.error("Error:", err);
      return null;
    }
  };

  const CalculatePriceBasedOnMode = async (Item) => {
    let params = {
      UserId: userId,
      Mode: selfWardMode,
      OriginalUnitId: itemList.find((i) => i.value === Item.ItemId)?.unitId,
      ...Item,
    };
    try {
      const response = await api.post(
        APIConstant.path.CalculatePriceBasedOnMode,
        params,
      );
      if (response.Success === 1) {
        return response;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getItemStocks = async (UserId) => {
    let params = {
      UserId: UserId || userId,
      FilterData: {
        item: [],
        unit: [],
        subWareHouse: [],
        combined: "Individual",
      },
    };
    api
      .post(APIConstant.path.FilterAuditOrderList, params)
      .then((response) => {
        if (response.Success === 1) {
          if (response.Data?.length) {
            let sortDataFifo = response.Data;
            sortDataFifo.sort(
              (a, b) => new Date(a.CreatedOn) - new Date(b.CreatedOn),
            );
            setItemStocks(sortDataFifo);
          }
        }
      })
      .catch((err) => { });
  };

  const validateForm = () => {
    let isValid = true;

    if (CommonConfig.isEmpty(invoiceNumber.name) && outwardMode !== "Self") {
      setInvoiceNumber({
        ...invoiceNumber,
        error: true,
        errorText: "Please enter invoice number",
      });
      isValid = false;
    } else {
      setInvoiceNumber({
        ...invoiceNumber,
        error: false,
        errorText: "",
      });
    }

    if (tabValue === 0) {
      rawDataList.forEach((data) => {
        if (
          CommonConfig.isEmpty(data.Item) ||
          CommonConfig.isEmpty(data.ItemId)
        ) {
          isValid = false;
          cogoToast.error("Please select Item");
        }
        // } else if (CommonConfig.isEmpty(data.Vendor)) {
        //   isValid = false;
        //   cogoToast.error("Please select Vendor");
        // } else if (
        //   CommonConfig.isEmpty(data.SubWarehouse) ||
        //   !subWareHouseList.find(
        //     (warehouse) => warehouse.value === data.SubWarehouse
        //   )
        // ) {
        //   isValid = false;
        //   cogoToast.error("Please select Subwarehouse");
        // }
      });
      convertedDataList.forEach((data) => {
        if (
          CommonConfig.isEmpty(data.Item) ||
          CommonConfig.isEmpty(data.ItemId)
        ) {
          isValid = false;
          cogoToast.error("Please select Item");
        }
        // } else if (CommonConfig.isEmpty(data.Vendor)) {
        //   isValid = false;
        //   cogoToast.error("Please select Vendor");
        // } else if (
        //   CommonConfig.isEmpty(data.SubWarehouse) ||
        //   !subWareHouseList.find(
        //     (warehouse) => warehouse.value === data.SubWarehouse
        //   )
        // ) {
        //   isValid = false;
        //   cogoToast.error("Please select Subwarehouse");
        // }
      });
    }

    if (tabValue === 1) {
      rawDataList.forEach((data) => {
        if (
          CommonConfig.isEmpty(data.Item) ||
          CommonConfig.isEmpty(data.ItemId)
        ) {
          isValid = false;
          cogoToast.error("Please select Item");
        } else if (
          CommonConfig.isEmpty(data.SubWarehouse) ||
          !subWareHouseList.find(
            (warehouse) => warehouse.value === data.SubWarehouse,
          )
        ) {
          isValid = false;
          cogoToast.error("Please select Subwarehouse");
        } else if (OutwardTabValue === 1 && CommonConfig.isEmpty(data.Client)) {
          isValid = false;
          cogoToast.error("Please select Client");
        } else if (
          OutwardTabValue === 0 &&
          CommonConfig.isEmpty(data.Equipment)
        ) {
          isValid = false;
          cogoToast.error("Please select Equipment");
        } else if (
          OutwardTabValue === 2 &&
          CommonConfig.isEmpty(data.ToSubWarehouse)
        ) {
          isValid = false;
          cogoToast.error("Please select SubWarehouse");
        }
      });
      convertedDataList.forEach((data) => {
        if (
          CommonConfig.isEmpty(data.Item) ||
          CommonConfig.isEmpty(data.ItemId)
        ) {
          isValid = false;
          cogoToast.error("Please select Item");
        } else if (
          CommonConfig.isEmpty(data.SubWarehouse) ||
          !subWareHouseList.find(
            (warehouse) => warehouse.value === data.SubWarehouse,
          )
        ) {
          isValid = false;
          cogoToast.error("Please select Subwarehouse");
        } else if (OutwardTabValue === 1 && CommonConfig.isEmpty(data.Client)) {
          isValid = false;
          cogoToast.error("Please select Client");
        } else if (
          OutwardTabValue === 0 &&
          CommonConfig.isEmpty(data.Equipment)
        ) {
          isValid = false;
          cogoToast.error("Please select Equipment");
        } else if (
          OutwardTabValue === 2 &&
          CommonConfig.isEmpty(data.ToSubWarehouse)
        ) {
          isValid = false;
          cogoToast.error("Please select SubWarehouse");
        }
      });
    }

    return isValid;
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const handleOutwardTabChange = (e, value) => {
    setOutwardTabValue(value);
    setOutwardTo(initialNameState);
    setProcess(initialNameArrayState);
    setSubWareHouse(initialNameState);
    setRawDataList([]);
    setConvertedDataList([]);
  };

  const handleOpen = async (e, type) => {
    if (type === "AddRawData") {
      addBlankRow();
    } else if (type === "MultiplyProcess") {
      setMultiplyProcessDialog(true);
    }
  };

  const handleClose = (type) => {
    if (type === "addDataDialog") {
      setAddDataDialog(false);
      setItem(initialNameState);
      setUnit(initialNameState);
      setQty(initialNameState);
      setDiscount(initialNameState);
      setCost(initialNameState);
      setGst(initialNameState);
      setVendorData(initialNameState);
      setSubWarehouseData(initialNameState);
      setReadOnly(false);
    } else if (type === "multiplyProcessDialog") {
      setMultiplyProcessDialog(false);
      setTempProcessMultiplyList(_.cloneDeep(processMultiplyList));
    }
  };

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const actionBodyMultiplyBy = (rowData, props) => {
    return (
      <>
        <TextField
          margin="dense"
          name="MultiplyBy"
          // label="Multiply By"
          type="text"
          value={rowData.MultiplyBy}
          onChange={(e) => handleMultiplyChange(e, props)}
          inputProps={{ maxLength: 10 }}
          fullWidth
        />
        X
      </>
    );
  };

  const handleMultiplyChange = (e, props) => {
    let tempProcessList = [...tempProcessMultiplyList];
    tempProcessList[props.rowIndex].MultiplyBy = e.target.value;
    setTempProcessMultiplyList(tempProcessList);
  };

  const handleChange = async (e, type) => {
    if (type === "inwardNumber") {
      if (CommonConfig.isEmpty(e.target.value)) {
        setInwardNumber({
          name: e.target.value,
          error: true,
          errorText: "Please enter number",
        });
      } else {
        setInwardNumber({
          name: e.target.value,
          error: false,
          errorText: "",
        });
      }
    } else if (type === "invoiceNumber") {
      if (CommonConfig.isEmpty(e.target.value)) {
        setInvoiceNumber({
          name: e.target.value,
          error: true,
          errorText: "Please enter invoice number",
        });
      } else {
        setInvoiceNumber({
          name: e.target.value,
          error: false,
          errorText: "",
        });
      }
    } else if (type === "order") {
      if (CommonConfig.isEmpty(e?.value)) {
        setOrder("");
        let tempRawData = [...rawDataList];
        tempRawData = tempRawData.filter((data) => !data.OrderId);
        setRawDataList(tempRawData);
      } else {
        let orderId = e?.value;
        setOrder(orderId);
        let tempRawData = [...rawDataList];
        let existingOrder = tempRawData.find(
          (data) => data.OrderId === orderId,
        );
        if (!existingOrder) {
          tempRawData = tempRawData.filter((data) => data.OrderId !== orderId);
          let tempOrder = orderList.find((ord) => ord.value === orderId);
          if (tempOrder) {
            let tempItemList = tempOrder.Items;
            tempItemList.forEach((item) => {
              let tempWare = subWareHouseList.find(
                (wh) => wh.value === item.GodownId,
              );
              tempRawData.push({
                OrderId: orderId,
                Item: item.Item,
                ItemId: item.ItemId,
                OriginalUnitId:
                  itemList.find((item) => item.value === item.ItemId)?.unitId ||
                  "",
                Unit: item.Unit,
                UnitId: item.UnitId,
                OriginalQuantity: item.OrderQuantity,
                OriginalCost: 0,
                OriginalDiscount: 0,
                OriginalGST: 0,
                OriginalPrice: 0,
                Quantity: item.OrderQuantity,
                Cost: 0,
                Discount: 0,
                GST:
                  itemList.find((item) => item.value === item.ItemId)
                    ?.product_rate || 0,
                Price: 0,
                Vendor: vendor.name && isApplyToAll ? vendor.name : "",
                Client: "",
                Equipment: "",
                SubWarehouse: tempWare ? item.GodownId : "",
                ToSubWarehouse: "",
              });
            });
          }
          setRawDataList(tempRawData);
        }
      }
    } else if (type === "process") {
      let tempRawData = [...rawDataList];
      let tempConvertedData = [...convertedDataList];

      if (e.target.value.length <= 0) {
        tempRawData = tempRawData.filter((data) => !data.ProcessId);
        tempConvertedData = tempConvertedData.filter((data) => !data.ProcessId);
        setRawDataList(tempRawData);
        setConvertedDataList(tempConvertedData);
        setProcessMultiplyList([]);
        setTempProcessMultiplyList([]);
        setProcess({
          name: [],
          error: true,
          errorText: "Please select process name",
        });
      } else {
        e.target.value.forEach(async (id) => {
          let processData = processList.find((data) => data._id === id);
          let existingProcess = tempRawData.find(
            (data) => data.ProcessId === id,
          );
          let tempProcessData = _.cloneDeep(processMultiplyList);
          if (!existingProcess) {
            tempProcessData.push({
              ProcessId: processData._id,
              ProcessName: processData.ProcessName,
              MultiplyBy: 1,
            });
          }
          setProcessMultiplyList(tempProcessData);
          setTempProcessMultiplyList(_.cloneDeep(tempProcessData));
          if (processData && processData.InputList?.length) {
            processData.InputList.forEach((input) => {
              if (!existingProcess) {
                let outwardToCheck =
                  tabValue === 1 && isApplyOutwardToAll && outwardTo.name;
                let subWarehouseCheck =
                  isApplySubWareHouseToAll && subWareHouse.name;
                let tempCost = 0;
                if (tabValue === 1) {
                  // if (input.Item && input.Quantity) {
                  //   let responsePrice = await CalculatePriceBasedOnMode({
                  //     Qty: input.Quantity,
                  //     ItemId: input.Item,
                  //     UnitId: input.Unit,
                  //     SubWarehouse:
                  //       isApplySubWareHouseToAll && subWareHouse.name,
                  //   });
                  //   if (responsePrice?.Price) {
                  //     tempCost = responsePrice.Price;
                  //   }
                  // }
                }
                tempRawData.push({
                  ProcessId: id,
                  Item: itemList.find((item) => item.value === input.Item)
                    ?.label,
                  ItemId: input.Item,
                  OriginalUnitId:
                    itemList.find((item) => item.value === input.Item)
                      ?.unitId || "",
                  Unit: unitList.find((item) => item.value === input.Unit)
                    ?.label,
                  UnitId: input.Unit,
                  OriginalQuantity: input.Quantity,
                  OriginalCost: 0,
                  OriginalDiscount: 0,
                  OriginalGST: 0,
                  OriginalPrice: 0,
                  Quantity: input.Quantity,
                  Cost: tempCost,
                  Discount: 0,
                  GST:
                    itemList.find((item) => item.value === input.Item)
                      ?.product_rate || 0,
                  Price: 0,
                  Vendor:
                    tabValue === 0 && vendor.name && isApplyToAll
                      ? vendor.name
                      : "",
                  Client:
                    outwardToCheck && OutwardTabValue === 1
                      ? outwardTo.name
                      : "",
                  Equipment:
                    outwardToCheck && OutwardTabValue === 0
                      ? outwardTo.name
                      : "",
                  SubWarehouse: subWarehouseCheck ? subWareHouse.name : "",
                  ToSubWarehouse:
                    outwardToCheck && OutwardTabValue === 2
                      ? outwardTo.name
                      : "",
                  MultiplyBy: 1,
                });
              }
            });
          }
          if (processData && processData.OutputList?.length) {
            processData.OutputList.forEach((output) => {
              let existingProcess = tempConvertedData.find(
                (data) => data.ProcessId === id,
              );
              if (!existingProcess) {
                let tempCost = 0;
                if (tabValue === 1) {
                  // if (output.Item && output.Quantity) {
                  //   let responsePrice = await CalculatePriceBasedOnMode({
                  //     Qty: output.Quantity,
                  //     ItemId: output.Item,
                  //     UnitId: output.Unit,
                  //     SubWarehouse:
                  //       isApplySubWareHouseToAll && subWareHouse.name,
                  //   });
                  //   if (responsePrice?.Price) {
                  //     tempCost = responsePrice.Price;
                  //   }
                  // }
                }
                let outwardToCheck =
                  tabValue === 1 && isApplyOutwardToAll && outwardTo.name;
                let subWarehouseCheck =
                  isApplySubWareHouseToAll && subWareHouse.name;
                tempConvertedData.push({
                  ProcessId: id,
                  Item: itemList.find((item) => item.value === output.Item)
                    ?.label,
                  ItemId: output.Item,
                  OriginalUnitId:
                    itemList.find((item) => item.value === output.Item)
                      ?.unitId || "",
                  Unit: unitList.find((item) => item.value === output.Unit)
                    ?.label,
                  UnitId: output.Unit,
                  OriginalQuantity: output.Quantity,
                  OriginalCost: 0,
                  OriginalDiscount: 0,
                  OriginalGST: 0,
                  OriginalPrice: 0,
                  Quantity: output.Quantity,
                  Cost: tempCost,
                  Discount: 0,
                  GST:
                    itemList.find((item) => item.value === output.Item)
                      ?.product_rate || 0,
                  Price: 0,
                  Vendor:
                    tabValue === 0 && vendor.name && isApplyToAll
                      ? vendor.name
                      : "",
                  Client:
                    outwardToCheck && OutwardTabValue === 1
                      ? outwardTo.name
                      : "",
                  Equipment:
                    outwardToCheck && OutwardTabValue === 0
                      ? outwardTo.name
                      : "",
                  SubWarehouse: subWarehouseCheck ? subWareHouse.name : "",
                  ToSubWarehouse:
                    outwardToCheck && OutwardTabValue === 2
                      ? outwardTo.name
                      : "",
                  MultiplyBy: 1,
                });
              }
            });
          }
        });
        process.name.forEach((id) => {
          if (!e.target.value.includes(id)) {
            tempRawData = tempRawData.filter((data) => data.ProcessId !== id);
            tempConvertedData = tempConvertedData.filter(
              (data) => data.ProcessId !== id,
            );
            setProcessMultiplyList((prevState) =>
              prevState.filter((list) => list.ProcessId !== id),
            );
            setTempProcessMultiplyList((prevState) =>
              prevState.filter((list) => list.ProcessId !== id),
            );
          }
        });
        setRawDataList(tempRawData);
        setConvertedDataList(tempConvertedData);
        setProcess({
          name: e.target.value,
          error: false,
          errorText: "",
        });
        // setTimeout(() => {
        //   document.getElementById("process-name").focus();
        //   multiSelectRef.current && multiSelectRef.current.show();
        // }, 0);
      }
    } else if (type === "remark") {
      setRemark(e.target.value);
    } else if (type === "vendor") {
      if (CommonConfig.isObjectEmpty(e?.value)) {
        setVendor({
          name: "",
          // error: true,
          // errorText: `Please select vendor`,
          error: false,
          errorText: "",
        });
      } else {
        setVendor({
          name: e.value,
          error: false,
          errorText: "",
        });
        if (isApplyToAll) {
          let tempRawData = [...rawDataList];
          tempRawData = tempRawData.map((data) => {
            data.Vendor = e.value;
            return data;
          });
          setRawDataList(tempRawData);
          let tempConvertedData = [...convertedDataList];
          tempConvertedData = tempConvertedData.map((data) => {
            data.Vendor = e.value;

            return data;
          });
          setConvertedDataList(tempConvertedData);
        }
      }
    } else if (type === "outwardTo") {
      if (CommonConfig.isObjectEmpty(e?.value)) {
        setOutwardTo({
          name: "",
          error: true,
          errorText: `Please select ${OutwardTabValue === 1
              ? "client"
              : OutwardTabValue === 0
                ? "equipment"
                : "sub warehouse"
            }`,
        });
      } else {
        setOutwardTo({
          name: e.value,
          error: false,
          errorText: "",
        });
        if (isApplyOutwardToAll) {
          let rawDataType = "Equipment";
          if (OutwardTabValue === 1) {
            rawDataType = "Client";
          } else if (OutwardTabValue === 2) {
            rawDataType = "ToSubWarehouse";
          }
          let tempRawData = [...rawDataList];
          tempRawData = tempRawData.map((data) => {
            data[rawDataType] = e.value;

            return data;
          });
          setRawDataList(tempRawData);
          let tempConvertedData = [...convertedDataList];
          tempConvertedData = tempConvertedData.map((data) => {
            data[rawDataType] = e.value;

            return data;
          });
          setConvertedDataList(tempConvertedData);
        }
      }
    } else if (type === "outwardToData") {
      if (CommonConfig.isObjectEmpty(e?.value)) {
        setOutwardToData({
          name: "",
          error: true,
          errorText: `Please select ${OutwardTabValue === 1
              ? "client"
              : OutwardTabValue === 0
                ? "equipment"
                : "sub warehouse"
            }`,
        });
      } else {
        setOutwardToData({
          name: e.value,
          error: false,
          errorText: "",
        });
      }
    } else if (type === "applyAll") {
      setIsApplyToAll((prevState) => !prevState);
      if (e.target.checked) {
        let tempRawData = [...rawDataList];
        tempRawData = tempRawData.map((data) => {
          if (vendor.name) {
            data.Vendor = vendor.name;
          }
          return data;
        });
        setRawDataList(tempRawData);
        let tempConvertedData = [...convertedDataList];
        tempConvertedData = tempConvertedData.map((data) => {
          if (vendor.name) {
            data.Vendor = vendor.name;
          }
          return data;
        });
        setConvertedDataList(tempConvertedData);
      }
    } else if (type === "applyOutwardToAll") {
      setIsApplyIsApplyOutwardToAll((prevState) => !prevState);
      if (e.target.checked) {
        let rawDataType = "Equipment";
        if (OutwardTabValue === 1) {
          rawDataType = "Client";
        } else if (OutwardTabValue === 2) {
          rawDataType = "ToSubWarehouse";
        }
        let tempRawData = [...rawDataList];
        tempRawData = tempRawData.map((data) => {
          if (outwardTo.name) {
            data[rawDataType] = outwardTo.name;
          }
          return data;
        });
        setRawDataList(tempRawData);
        let tempConvertedData = [...convertedDataList];
        tempConvertedData = tempConvertedData.map((data) => {
          if (outwardTo.name) {
            data[rawDataType] = outwardTo.name;
          }
          return data;
        });
        setConvertedDataList(tempConvertedData);
      }
    } else if (type === "listData") {
      if (CommonConfig.isObjectEmpty(e?.value)) {
        setVendorData({
          name: "",
          error: true,
          errorText: `Please select vendor`,
        });
      } else {
        setVendorData({
          name: e.value,
          error: false,
          errorText: "",
        });
      }
    } else if (type === "subwarehouse") {
      if (CommonConfig.isObjectEmpty(e?.value)) {
        setSubWareHouse({
          name: "",
          error: false,
          // errorText: `Please select Sub Warehouse`,
          errorText: "",
        });
      } else {
        setSubWareHouse({
          name: e.value,
          error: false,
          errorText: "",
        });
        if (isApplySubWareHouseToAll) {
          let tempRawData = [...rawDataList];
          tempRawData = tempRawData.map((data) => {
            data.SubWarehouse = e.value;

            return data;
          });
          setRawDataList(tempRawData);
          let tempConvertedData = [...convertedDataList];
          tempConvertedData = tempConvertedData.map((data) => {
            data.SubWarehouse = e.value;

            return data;
          });
          setConvertedDataList(tempConvertedData);
        }
      }
    } else if (type === "applySubWareHouseToAll") {
      setIsApplySubWareHouseToAll((prevState) => !prevState);
      if (e.target.checked) {
        let tempRawData = [...rawDataList];
        tempRawData = tempRawData.map((data) => {
          if (subWareHouse) {
            data.SubWarehouse = subWareHouse.name;
          }
          return data;
        });
        setRawDataList(tempRawData);
        let tempConvertedData = [...convertedDataList];
        tempConvertedData = tempConvertedData.map((data) => {
          if (subWareHouse.name) {
            data.SubWarehouse = subWareHouse.name;
          }
          return data;
        });
        setConvertedDataList(tempConvertedData);
      }
    } else if (type === "subWarehouseData") {
      if (CommonConfig.isObjectEmpty(e.value)) {
        setSubWarehouseData({
          name: "",
          error: true,
          errorText: `Please select Sub-Warehouse`,
        });
      } else {
        setSubWarehouseData({
          name: e.value,
          error: false,
          errorText: "",
        });
        if (item.name && qty.name) {
          let responsePrice = await CalculatePriceBasedOnMode({
            Qty: qty.name,
            ItemId: item.name,
            UnitId: unit.name,
            UnitId: unit.name,
            SubWarehouse: e.value,
          });
          if (responsePrice?.Price) {
            setCost({
              name: responsePrice.Price / parseFloat(qty.name || 1),
              error: false,
              errorText: "",
            });
          } else {
            setCost({
              name: "0",
              error: false,
              errorText: "",
            });
          }
        }
      }
    } else if (type === "item") {
      if (CommonConfig.isObjectEmpty(e?.value)) {
        setItem({
          name: "",
          error: true,
          errorText: "Please enter item",
        });
      } else {
        setItem({
          name: e.value,
          error: false,
          errorText: "",
        });
        let unitId =
          itemList.find((item) => item.value === e.value)?.unitId || "";
        setUnit({
          name: unitId,
          error: false,
          errorText: "",
        });
        if (qty.name) {
          let responsePrice = await CalculatePriceBasedOnMode({
            Qty: qty.name,
            ItemId: e.value,
            UnitId: unitId,
            SubWarehouse: subWarehouseData.name,
          });
          if (responsePrice?.Price) {
            setCost({
              name: responsePrice.Price / parseFloat(qty.name || 1),
              error: false,
              errorText: "",
            });
          } else {
            setCost({
              name: "0",
              error: false,
              errorText: "",
            });
          }
        }
        setGst({
          name:
            itemList.find((item) => item.value === e.value)?.product_rate || 0,
          error: false,
          errorText: "",
        });
      }
    } else if (type === "unit") {
      if (CommonConfig.isObjectEmpty(e?.value)) {
        setUnit({
          name: "",
          error: true,
          errorText: "Please enter unit",
        });
      } else {
        setUnit({
          name: e.value,
          error: false,
          errorText: "",
        });
        if (item.name && qty.name) {
          let responsePrice = await CalculatePriceBasedOnMode({
            Qty: qty.name,
            ItemId: item.name,
            UnitId: e.value,
            SubWarehouse: subWarehouseData.name,
          });
          if (responsePrice?.Price) {
            setCost({
              name: responsePrice.Price / parseFloat(qty.name || 1),
              error: false,
              errorText: "",
            });
          } else {
            setCost({
              name: "0",
              error: false,
              errorText: "",
            });
          }
        }
      }
    } else if (type === "qty") {
      if (CommonConfig.isEmpty(e.target.value)) {
        setQty({
          name: e.target.value,
          error: true,
          errorText: "Please enter quantity",
        });
      } else if (/^\d*\.?\d*$/i.test(e.target.value)) {
        setQty({
          name: e.target.value,
          error: false,
          errorText: "",
        });
        if (item.name) {
          let responsePrice = await CalculatePriceBasedOnMode({
            Qty: e.target.value,
            ItemId: item.name,
            UnitId: unit.name,
            SubWarehouse: subWarehouseData.name,
          });
          if (responsePrice?.Price) {
            setCost({
              name: responsePrice.Price / parseFloat(e.target.value || 1),
              error: false,
              errorText: "",
            });
          } else {
            setCost({
              name: "0",
              error: false,
              errorText: "",
            });
          }
        }
      }
    } else if (type === "cost") {
      if (CommonConfig.isEmpty(e.target.value)) {
        setCost({
          name: e.target.value,
          error: true,
          errorText: "Please enter cost",
        });
      } else if (/^\d*\.?\d*$/.test(e.target.value)) {
        setCost({
          name: e.target.value,
          error: false,
          errorText: "",
        });
      }
    } else if (type === "discount") {
      if (CommonConfig.isEmpty(e.target.value)) {
        setDiscount({
          name: e.target.value,
          error: true,
          errorText: "Please enter discount",
        });
      } else if (/^\d*\.?\d*$/.test(e.target.value)) {
        setDiscount({
          name: e.target.value,
          error: false,
          errorText: "",
        });
      }
    } else if (type === "gst") {
      if (CommonConfig.isEmpty(e?.value)) {
        setGst({
          name: e?.value,
          error: true,
          errorText: "Please enter gst",
        });
      } else {
        setGst({
          name: e.value,
          error: false,
          errorText: "",
        });
      }
    }
  };

  const addBlankRow = () => {
    let from = vendor.name;
    let to = subWareHouse.name;
    let outwardToCheck = tabValue === 1 && outwardTo.name;

    const newItem = {
      ProcessId: "",
      Item: "",
      ItemId: "",
      OriginalUnitId: "",
      Unit: "",
      UnitId: "",
      Quantity: "",
      Cost: 0,
      OriginalCost: 0,
      Discount: 0,
      GST: 0,
      Price: 0,
      Vendor: tabValue === 0 ? (isApplyToAll ? from : "") : "",
      SubWarehouse: isApplySubWareHouseToAll ? to : "",
      Client:
        outwardToCheck && OutwardTabValue === 1
          ? isApplyOutwardToAll
            ? outwardTo.name
            : ""
          : "",
      Equipment:
        outwardToCheck && OutwardTabValue === 0
          ? isApplyOutwardToAll
            ? outwardTo.name
            : ""
          : "",
      ToSubWarehouse:
        outwardToCheck && OutwardTabValue === 2
          ? isApplyOutwardToAll
            ? outwardTo.name
            : ""
          : "",
      MultiplyBy: 1,
      ...(tabValue === 1 && { AvailableQuantity: 0 }),
    };

    setRawDataList([...rawDataList, newItem]);
  };

  const handleMultiplyProcess = () => {
    setProcessMultiplyList(_.cloneDeep(tempProcessMultiplyList));
    let processMultiplyObj = {};
    tempProcessMultiplyList.forEach((process) => {
      processMultiplyObj[process.ProcessId] = process.MultiplyBy;
    });
    let tempRawData = [...rawDataList];
    tempRawData.forEach((data) => {
      if (data.ProcessId) {
        data.Quantity =
          processMultiplyObj[data.ProcessId] * data.OriginalQuantity;
        data.Price = calculatePrice(data);
      }
    });
    setRawDataList(tempRawData);
    let tempConvertedData = [...convertedDataList];
    tempConvertedData.forEach((data) => {
      if (data.ProcessId) {
        data.Quantity =
          processMultiplyObj[data.ProcessId] * data.OriginalQuantity;
        data.Price = calculatePrice(data);
      }
    });
    setConvertedDataList(tempConvertedData);
    setMultiplyProcessDialog(false);
  };

  const actionBodyData = (rowData, props, input, type) => {
    if (input === "Dropdown1") {
      let rowDataList = vendorList;
      if (tabValue === 1) {
        rowDataList = subWareHouseList;
      }
      return (
        <Autocomplete
          id={type}
          name={type}
          value={
            rowData[getRawDataLabel().Input1.value] && rowDataList.length
              ? rowDataList.filter(
                (y) => y.value == rowData[getRawDataLabel().Input1.value],
              )[0]
              : ""
          }
          options={rowDataList}
          getOptionLabel={(option) => (option.label ? option.label : option)}
          disabled={readOnly}
          onChange={(e, value) =>
            handlerowDataChange(
              rowData,
              value?.value || "",
              props,
              getRawDataLabel().Input1.value,
              type,
            )
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              // label={getRawDataLabel().Input1.label}
              disabled={readOnly}
            />
          )}
        />
      );
    }
    if (input === "Dropdown2") {
      let rowDataList = subWareHouseList;
      if (tabValue === 1) {
        switch (OutwardTabValue) {
          case 1:
            rowDataList = clientList;
            break;
          case 0:
            rowDataList = equipmentList;
            break;
        }
      }
      return (
        <Autocomplete
          id={type}
          name={type}
          disabled={readOnly}
          value={
            rowData[getRawDataLabel().Input2.value] && rowDataList.length
              ? rowDataList.filter(
                (y) => y.value == rowData[getRawDataLabel().Input2.value],
              )[0]
              : ""
          }
          options={rowDataList}
          getOptionLabel={(option) => (option.label ? option.label : option)}
          onChange={(e, value) =>
            handlerowDataChange(
              rowData,
              value?.value || "",
              props,
              getRawDataLabel().Input2.value,
              type,
            )
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              // label={getRawDataLabel().Input2.label}
              disabled={readOnly}
            />
          )}
        />
      );
    }

    if (input === "GST") {
      return (
        <Autocomplete
          id={type}
          name={type}
          value={
            (rowData.GST || rowData.GST === 0) && gstList.length
              ? gstList.filter((y) => y.value == rowData.GST)[0]
              : ""
          }
          options={gstList}
          getOptionLabel={(option) => (option.label ? option.label : option)}
          disabled={readOnly}
          onChange={(e, value) =>
            handlerowDataChange(rowData, value?.value || "", props, "GST", type)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              // label="GST"
              disabled={readOnly}
            />
          )}
        />
      );
    }
    return (
      <TextField
        margin="dense"
        name={type}
        type="text"
        value={rowData[input]}
        inputProps={{ maxLength: 10 }}
        onChange={(e) =>
          handlerowDataChange(rowData, e.target.value, props, input, type)
        }
        fullWidth
        disabled={readOnly}
      />
    );
  };

  // const calculatePrice = (data) => {
  //   let { Quantity, OriginalCost, GST, Discount, Price } = data;
  //   OriginalCost = OriginalCost ? parseFloat(OriginalCost) : 0;
  //   let price = OriginalCost || 0;
  //   Quantity = Quantity ? parseFloat(Quantity) : 1;
  //   Discount = Discount ? parseFloat(Discount) : 0;
  //   GST = GST ? parseFloat(GST) : 0;

  //   if (OriginalCost) {
  //     if (Discount) {
  //       price -= OriginalCost * (Discount / 100);
  //     }
  //     if (GST) {
  //       price += OriginalCost * (GST / 100);
  //     }
  //   }
  //   return (price * Quantity).toFixed(2);
  // };

  const calculatePrice = (data) => {
    let { Quantity, OriginalCost, GST, Discount } = data;

    Quantity = Quantity ? parseFloat(Quantity) : 0;
    OriginalCost = OriginalCost ? parseFloat(OriginalCost) : 0;
    GST = GST ? parseFloat(GST) : 0;
    Discount = Discount ? parseFloat(Discount) : 0;

    let total = Quantity * OriginalCost;

    let discountAmount = total * (Discount / 100);

    let afterDiscount = total - discountAmount;

    let gstAmount = afterDiscount * (GST / 100);

    let finalPrice = afterDiscount + gstAmount;

    return finalPrice.toFixed(2);
  };

  const handlerowDataChange = async (rowData, e, props, input, type) => {
    if (
      input === "Cost" ||
      input === "GST" ||
      input === "Discount" ||
      input === "Quantity"
    ) {
      if (!(/^\d*\.?\d*$/.test(e) || e === "")) {
        return;
      }
    }

    if (type === "Raw") {
      let tempRawData = [...rawDataList];
      if (input === "Quantity") {
        var inputValue = e != "" ? parseFloat(e) : "";
        if ((!inputValue || inputValue <= 0) && inputValue != "") {
          cogoToast.error("Quantity must be greater than 0.");
          return;
        }

        let quantityAvailable = 0;
        var quantityData = itemStocks.filter(
          (y) => y?.ItemId == rowData?.ItemId,
        );
        if (quantityData.length) {
          if (rowData?.SubWarehouse) {
            var qtyAvailable = quantityData[0]?.QuantityDetails.filter(
              (x) => x?.SubWarehouseId == rowData?.SubWarehouse,
            );
            quantityAvailable = qtyAvailable?.length
              ? qtyAvailable[0]?.Quantity
              : 0;
          } else {
            quantityAvailable = quantityData.reduce((sum, item) => {
              return (
                sum +
                item.QuantityDetails.reduce(
                  (subSum, detail) => subSum + (detail.Quantity || 0),
                  0,
                )
              );
            }, 0);
          }
        }

        if (stockId !== "" && !readOnly) {
          if (editRawDataList[props.rowIndex]) {
            let tempData = editRawDataList[props.rowIndex];
            if (
              rowData.SubWarehouse &&
              tempData.ItemId === rowData.ItemId &&
              tempData.UnitId === rowData.UnitId &&
              tempData.SubWarehouse === rowData.SubWarehouse &&
              tempData.Quantity
            ) {
              // quantityAvailable += parseInt(tempData.Quantity);
            }
          }
        }
        let response = await checkUnitConversion({
          OriginalUnitId:
            itemList.find((i) => i.value === rowData.ItemId)?.unitId || "",
          UnitId: rowData.UnitId,
        });
        if (response.Data) {
          quantityAvailable = quantityAvailable / response.Data;
        } else if (!response.Success) {
          quantityAvailable = 0;
        }
        if (
          (quantityAvailable === 0 || quantityAvailable < inputValue) &&
          tabValue === 1
        ) {
          tempRawData[props.rowIndex].AvailableQuantity = 0;
          cogoToast.error("Selected Quantity is not available in the stock.");
          return;
        } else {
          tempRawData[props.rowIndex][input] = inputValue;
          let tempCost = tempRawData[props.rowIndex].Cost;
          if (tabValue === 1 && inputValue) {
            let responsePrice = await CalculatePriceBasedOnMode({
              Qty: inputValue,
              ItemId: tempRawData[props.rowIndex].ItemId,
              UnitId: tempRawData[props.rowIndex].UnitId,
              SubWarehouse: tempRawData[props.rowIndex].SubWarehouse,
            });
            if (responsePrice?.Price) {
              tempCost = responsePrice.Price / parseFloat(inputValue || 1);
            }
          }
          if (inputValue != "") {
            let latestAvailable = (
              parseFloat(quantityAvailable) - parseFloat(inputValue)
            ).toString();
            tempRawData[props.rowIndex].Cost = tempCost;
            tempRawData[props.rowIndex].OriginalCost = tempCost;
            tempRawData[props.rowIndex].AvailableQuantity = latestAvailable;
            let price = calculatePrice(tempRawData[props.rowIndex]);
            tempRawData[props.rowIndex].Price = price;
          } else {
            let latestAvailable = quantityAvailable.toString();
            tempRawData[props.rowIndex].AvailableQuantity = latestAvailable;
          }
        }
      }

      if (input === "Cost") {
        tempRawData[props.rowIndex].OriginalCost = e || 0;
      }
      if (input === "Cost" || input === "GST" || input === "Discount") {
        tempRawData[props.rowIndex][input] = e;
        let price = calculatePrice(tempRawData[props.rowIndex]);
        tempRawData[props.rowIndex].Price = price;
      } else {
        tempRawData[props.rowIndex][input] = e;
      }
      if (input === "SubWarehouse") {
        if (
          e &&
          tempRawData[props.rowIndex].ItemId &&
          tempRawData[props.rowIndex].Quantity
        ) {
          let responsePrice = await CalculatePriceBasedOnMode({
            Qty: tempRawData[props.rowIndex].Quantity,
            ItemId: tempRawData[props.rowIndex].ItemId,
            UnitId: tempRawData[props.rowIndex].UnitId,
            SubWarehouse: e,
          });
          if (responsePrice?.Price) {
            tempRawData[props.rowIndex].Cost = responsePrice?.Price / parseFloat(tempRawData[props.rowIndex].Quantity || 1);
          } else {
            tempRawData[props.rowIndex].Cost = 0;
          }
        }
      }
      setRawDataList(tempRawData);
    } else {
      let tempConvertedData = [...convertedDataList];
      tempConvertedData[props.rowIndex][input] = e;
      if (input === "Cost") {
        tempConvertedData[props.rowIndex].OriginalCost = e || 0;
      }
      if (input === "Cost" || input === "GST" || input === "Discount") {
        let price = calculatePrice(tempConvertedData[props.rowIndex]);
        tempConvertedData[props.rowIndex][input] = e;
        tempConvertedData[props.rowIndex].Price = price;
      } else {
        tempConvertedData[props.rowIndex][input] = e;
      }
      if (input === "SubWarehouse") {
        if (
          e &&
          tempConvertedData[props.rowIndex].ItemId &&
          tempConvertedData[props.rowIndex].Quantity
        ) {
          let responsePrice = await CalculatePriceBasedOnMode({
            Qty: tempConvertedData[props.rowIndex].Quantity,
            ItemId: tempConvertedData[props.rowIndex].ItemId,
            UnitId: tempConvertedData[props.rowIndex].UnitId,
            SubWarehouse: e,
          });
          if (responsePrice?.Price) {
            tempConvertedData[props.rowIndex].Cost = responsePrice?.Price / parseFloat(tempConvertedData[props.rowIndex].Quantity || 1);
          } else {
            tempConvertedData[props.rowIndex].Cost = 0;
          }
        }
      }
      setConvertedDataList(tempConvertedData);
    }
  };

  const getRawDataLabel = () => {
    let Input1 = {
      label: "Vendor's Name",
      value: "Vendor",
    };
    let Input2 = {
      label: "Sub-warehouse",
      value: "SubWarehouse",
    };
    if (tabValue === 1) {
      Input1 = {
        label: "From Sub-warehouse",
        value: "SubWarehouse",
      };
      switch (OutwardTabValue) {
        case 1:
          Input2 = {
            label: "Client's Name",
            value: "Client",
          };
          break;
        case 0:
          Input2 = {
            label: "Equipment's Name",
            value: "Equipment",
          };
          break;
        case 2:
          Input2 = {
            label: "To Sub-warehouse",
            value: "ToSubWarehouse",
          };
          break;
      }
    }

    return { Input1, Input2 };
  };

  const getAvailableItemQuantity = (itemId, subWareHouseId) => {
    let quantityAvailable = 0;
    var quantityData = itemStocks.filter((y) => y?.ItemId == itemId);
    if (itemId && quantityData.length) {
      if (subWareHouseId) {
        var qtyAvailable = quantityData[0]?.QuantityDetails.filter(
          (x) => x?.SubWarehouseId == subWareHouseId,
        );
        quantityAvailable = qtyAvailable ? qtyAvailable[0]?.Quantity : 0;
        // return itemStocks[itemId][subWareHouseId] || 0;
        return quantityAvailable || 0;
      } else {
        // return Object.values(itemStocks[itemId]).reduce(
        //   (sum, qty) => sum + qty,
        //   0
        // );
        return quantityData.reduce((sum, item) => {
          return (
            sum +
            item?.QuantityDetails.reduce(
              (subSum, detail) => subSum + (detail.Quantity || 0),
              0,
            )
          );
        }, 0);
      }
    } else return 0;
  };

  // Get Outward Mode API here
  const getGeneralConfiguration = async () => {
    try {
      setLoading(true);
      let data = {
        CreatedBy: CommonConfig.loginData()?._id,
      };
      await api
        .post(APIConstant.path.GetOutwardMode, data)
        .then(async (response) => {
          if (response.Success) {
            setOutwardMode(response?.Data?.OutwardMode);
            setSelfWardMode(response?.Data?.SelfMode);
            setConfigurationId(response?.Data?._id);
            if (response?.Data?.OutwardMode === "Sell") {
              setOutwardTabValue(1);
            } else {
              setOutwardTabValue(0);
            }
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          cogoToast.error(err);
        });
    } catch (err) {
      setLoading(false);
      cogoToast.error(err);
    }
  };

  // Get Outward Mode API End Here

  let outwardToList =
    OutwardTabValue === 1
      ? clientList
      : OutwardTabValue === 0
        ? equipmentList
        : subWareHouseList;

  const grandTotal = React.useMemo(() => {
    let total = 0;
    if (Array.isArray(rawDataList)) {
      total += rawDataList.reduce((s, r) => s + (parseFloat(r.Price) || 0), 0);
    }
    if (Array.isArray(convertedDataList)) {
      total += convertedDataList.reduce(
        (s, r) => s + (parseFloat(r.Price) || 0),
        0,
      );
    }
    return total.toFixed(2);
  }, [rawDataList, convertedDataList]);

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard e-inward-stock">
      <div>
        <div className="heading-area p-d-flex p-ai-center p-jc-between p-mb-2">
          <div
            className="p-d-flex p-ai-center p-jc-between"
            onClick={() => props.history.push("/admin/inward-stock")}
          >
            <i className="pi pi-chevron-left" />
            <h2>
              {stockId !== "" ? (readOnly ? "View " : "Edit ") : "Add "}
              Inward Stock
            </h2>
          </div>

          <div className="heading-area-right">
            {!readOnly ? (
              <div>
                <div className="add-btn1" onClick={(e) => addStock(e)}>
                  <i className="icon-add"></i> Submit
                </div>
              </div>
            ) : (
              <div>
                <div
                  className="add-btn1"
                  onClick={() => props.history.push("/admin/inward-stock")}
                >
                  <i className="pi pi-chevron-left"></i> Back to Stock
                </div>
              </div>
            )}
          </div>
        </div>
        <hr />
        <div className="p-px-3 p-mt-4">
          {/* Add outward mode code here */}
          {/* {tabValue === 1 && (
          <div>
            <Dropdown
              value={outwardMode}
              options={configurationList}
              onChange={(e) => setOutwardMode(e.value)}
              placeholder={loading ? "Loading..." : "Select Outward Mode"}
              style={{ width: "200px", marginRight: "50px" }}
              disabled={loading}
            />
            {outwardMode === "Self" && (
              <Dropdown
                value={selfWardMode}
                options={selfModeOptions}
                onChange={(e) => setSelfWardMode(e.value)}
                placeholder={loading ? "Loading..." : "Select Self Mode"}
                style={{ width: "200px" }}
                disabled={loading}
              />
            )}
          </div>
        )} */}
          {/* Add outward mode code End here */}
          <GridContainer className="p-w-100">
            {tabValue === 1 && (
              <>
                <GridItem xs={12} sm={6} md={4}>
                  <Autocomplete
                    id="outward-mode"
                    options={configurationList}
                    getOptionLabel={(option) =>
                      option.label ? option.label : option
                    }
                    value={
                      outwardMode && configurationList.length
                        ? configurationList.find((y) => y.value === outwardMode)
                        : null
                    }
                    style={{ marginTop: "22px" }}
                    onChange={(e, value) => {
                      if (value?.value === "Self") {
                        handleOutwardTabChange(e, 0);
                      } else if (value?.value === "Sell") {
                        handleOutwardTabChange(e, 1);
                      }
                      setOutwardMode(value?.value || "");
                    }}
                    disabled={loading}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        placeholder={
                          loading ? "Loading..." : "Select Outward Mode"
                        }
                        label="Outward Mode"
                        // style={{ width: "200px", marginRight: "50px" }}
                        disabled={loading}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </GridItem>

                {outwardMode === "Self" && (
                  <GridItem xs={12} sm={6} md={4}>
                    <Autocomplete
                      id="self-mode"
                      options={selfModeOptions}
                      getOptionLabel={(option) =>
                        option.label ? option.label : option
                      }
                      value={
                        selfWardMode && selfModeOptions.length
                          ? selfModeOptions.find((y) => y.value === selfWardMode)
                          : null
                      }
                      style={{ marginTop: "22px" }}
                      onChange={(e, value) => setSelfWardMode(value?.value || "")}
                      disabled={loading}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          placeholder={
                            loading ? "Loading..." : "Select Self Mode"
                          }
                          label="Self Mode"
                          InputLabelProps={{ shrink: true }}
                          disabled={loading}
                        />
                      )}
                    />
                  </GridItem>
                )}
              </>
            )}
            <GridItem xs={12} sm={6} md={4}>
              <TextField
                style={{ marginTop: "14px" }}
                margin="dense"
                name="InwardId"
                label={tabValue === 0 ? "Inward Id" : "Outward Id"}
                type="text"
                value={inwardNumber.name}
                onChange={(e) => handleChange(e, "inwardNumber")}
                error={inwardNumber.error}
                helperText={inwardNumber.errorText}
                disabled={true}
                inputProps={{ maxLength: 50 }}
                fullWidth
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={4}>
              <Datetime
                value={dateTime ? moment(dateTime) : moment()}
                dateFormat="DD/MM/YYYY"
                timeFormat="HH:mm"
                onChange={(e) => setDateTime(e)}
                closeOnSelect={true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    style={{ marginTop: "11px" }}
                    label={tabValue === 0 ? "Inward Date" : "Outward Date"}
                    fullWidth
                    disabled={readOnly}
                  />
                )}
              />
            </GridItem>
            {/* {tabValue === 0 && (
            <GridItem xs={12} sm={6} md={4}>
              <div className="input-control select p-d-flex p-pt-4">
                <FormControl fullWidth>
                  <Autocomplete
                    id="Order No"
                    name="Order No"
                    value={
                      order && orderList.length
                        ? orderList.filter((y) => y.value == order)[0]
                        : ""
                    }
                    options={orderList}
                    getOptionLabel={(option) =>
                      option.label ? option.label : option
                    }
                    disabled={readOnly}
                    onChange={(e, value) => handleChange(value, "order")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        placeholder={"Order No"}
                        label={"Order No"}
                        disabled={readOnly}
                      />
                    )}
                  />
                </FormControl>
              </div>
            </GridItem>
          )} */}
            {/* <GridItem xs={12} sm={6} md={4}> */}
            {/* <div className="input-control select p-d-flex"> */}
            {/* <FormControl fullWidth> */}
            {/* <label htmlFor="simple-select">Process Name</label>
                <div className="p-d-flex p-ai-end"> */}
            {/* <MultiSelect
                    ref={multiSelectRef}
                    id="react-multiselect"
                    inputId="process-name"
                    value={process.name}
                    onChange={(e) => handleChange(e, "process")}
                    options={processList}
                    optionLabel="label"
                    placeholder="Process Name"
                    className="p-w-100 e-border-none"
                    disabled={readOnly}
                    closeOnSelect={false}
                  /> */}

            {/* <span className="error-msg" style={{ color: "red" }}>
                        {process.error ? process.errorText : null}
                      </span> */}
            {/* {!readOnly && (
                    <div
                      className="filter-btn cursor-pointer"
                      onClick={(e) => handleOpen(e, "MultiplyProcess")}
                    >
                      <i className="icon-add"></i>
                    </div>
                  )} */}
            {/* </div> */}
            {/* </FormControl> */}
            {/* </div> */}
            {/* </GridItem> */}
            {/* {outwardMode !== "Self" && ( */}
            <GridItem xs={12} sm={6} md={4}>
              <TextField
                autoFocus
                margin="dense"
                name="InvoiceNumber"
                label="Invoice Number"
                type="text"
                value={invoiceNumber.name}
                onChange={(e) => handleChange(e, "invoiceNumber")}
                error={invoiceNumber.error}
                helperText={invoiceNumber.errorText}
                disabled={readOnly}
                inputProps={{ maxLength: 50 }}
                fullWidth
                className="p-pt-1"
              />
            </GridItem>
            {/* )} */}
            {tabValue === 0 && (
              <GridItem xs={12} sm={6} md={6}>
                <div className="input-control select p-d-flex">
                  <FormControl fullWidth>
                    <div className="p-d-flex p-ai-center p-jc-between">
                      <Autocomplete
                        className="p-w-100 p-mt-2"
                        id="vendor"
                        name="vendor"
                        value={
                          vendor.name && vendorList.length
                            ? vendorList.filter((y) => y.value == vendor.name)[0]
                            : ""
                        }
                        options={vendorList}
                        getOptionLabel={(option) =>
                          option.label ? option.label : option
                        }
                        disabled={readOnly}
                        onChange={(e, value) => handleChange(value, "vendor")}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder={"Vendor Name"}
                            error={vendor.error}
                            helperText={vendor.errorText}
                            label={"Vendor Name"}
                            disabled={readOnly}
                          />
                        )}
                      />
                      {!readOnly &&
                        userPageAccess.includes("Add Manual Network") && (
                          <div
                            className="filter-btn cursor-pointer p-mt-3"
                            onClick={() => setAddVendorModal(true)}
                            style={{ marginLeft: "5px" }}
                          >
                            <i className="icon-add"></i>
                          </div>
                        )}
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={"ApplyAllVendor"}
                            checked={isApplyToAll}
                            onChange={(e) => handleChange(e, "applyAll")}
                            disabled={readOnly || !vendor.name}
                          />
                        }
                        style={{ width: "100%", marginLeft: "10px" }}
                        label={`Apply this ${tabValue === 0 ? "vendor" : "client"
                          }'s name to
                    all`}
                      />
                    </div>
                  </FormControl>
                </div>
              </GridItem>
            )}
            {tabValue === 1 && (
              <GridItem
                xs={12}
                sm={12}
                md={12}
                className="p-mt-4 p-p-0 e-button-group"
              >
                <ButtonGroup>
                  {outwardMode === "Self" && (
                    <Button
                      label="Machinery"
                      className={
                        OutwardTabValue === 0
                          ? "p-button-primary"
                          : "p-button-outlined"
                      }
                      onClick={() => handleOutwardTabChange(null, 0)}
                    />
                  )}
                  {outwardMode === "Sell" && (
                    <Button
                      label="Sell"
                      className={
                        OutwardTabValue === 1
                          ? "p-button-primary"
                          : "p-button-outlined"
                      }
                      onClick={() => handleOutwardTabChange(null, 1)}
                    />
                  )}
                  {outwardMode === "Self" && (
                    <Button
                      label="Warehouse"
                      className={
                        OutwardTabValue === 2
                          ? "p-button-primary"
                          : "p-button-outlined"
                      }
                      onClick={() => handleOutwardTabChange(null, 2)}
                    />
                  )}
                </ButtonGroup>
              </GridItem>
            )}

            <GridItem xs={12} sm={6} md={6}>
              <div className="input-control select p-d-flex">
                <FormControl fullWidth>
                  <div className="p-d-flex p-ai-center p-jc-between">
                    <Autocomplete
                      id="subwarehouse"
                      name="subwarehouse"
                      className="p-w-100"
                      value={
                        subWareHouse.name && subWareHouseList.length
                          ? subWareHouseList.filter(
                            (y) => y.value == subWareHouse.name,
                          )[0]
                          : ""
                      }
                      options={subWareHouseList}
                      getOptionLabel={(option) =>
                        option.label ? option.label : option
                      }
                      disabled={readOnly}
                      onChange={(e, value) => handleChange(value, "subwarehouse")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          placeholder="Select Sub Warehouse"
                          error={subWareHouse.error}
                          helperText={subWareHouse.errorText}
                          label={
                            tabValue === 0
                              ? "Sub-Warehouse"
                              : "From Sub-warehouse"
                          }
                          disabled={readOnly}
                        />
                      )}
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isApplySubWareHouseToAll}
                          onChange={(e) =>
                            handleChange(e, "applySubWareHouseToAll")
                          }
                          disabled={readOnly || !subWareHouse.name}
                        />
                      }
                      style={{ width: "100%", marginLeft: "10px" }}
                      label=" Apply this Sub-Warehouse to all"
                    />
                  </div>
                </FormControl>
              </div>
            </GridItem>

            {tabValue === 1 ? (
              <GridItem xs={12} sm={6} md={6}>
                <div className="input-control select p-d-flex">
                  <FormControl fullWidth>
                    <div className="p-d-flex align-center p-jc-between">
                      <Autocomplete
                        className="p-w-100"
                        id="outwardTo"
                        name="outwardTo"
                        value={
                          outwardTo.name && outwardToList.length
                            ? outwardToList.filter(
                              (y) => y.value == outwardTo.name,
                            )[0]
                            : ""
                        }
                        options={outwardToList}
                        getOptionLabel={(option) =>
                          option.label ? option.label : option
                        }
                        disabled={readOnly}
                        onChange={(e, value) => handleChange(value, "outwardTo")}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            placeholder="Select"
                            error={outwardTo.error}
                            helperText={outwardTo.errorText}
                            label={
                              OutwardTabValue === 1
                                ? "Party's Name"
                                : OutwardTabValue === 0
                                  ? "Equipment’s Name"
                                  : "To Sub-warehouse"
                            }
                            InputLabelProps={{ style: { width: "100%" } }}
                            disabled={readOnly}
                          />
                        )}
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isApplyOutwardToAll}
                            onChange={(e) => handleChange(e, "applyOutwardToAll")}
                            disabled={readOnly || !outwardTo.name}
                          />
                        }
                        style={{ width: "100%", marginLeft: "10px" }}
                        label={` Apply this ${OutwardTabValue === 1
                            ? "client"
                            : OutwardTabValue === 0
                              ? "equipment"
                              : "sub-warehouse"
                          } to all`}
                      />
                    </div>
                  </FormControl>
                </div>
              </GridItem>
            ) : null}
            <GridItem xs={12} sm={12} md={12}>
              <TextField
                margin="dense"
                name="Remark"
                label="Remark"
                type="text"
                disabled={readOnly}
                value={remark.name}
                onChange={(e) => handleChange(e, "remark")}
                error={remark.error}
                helperText={remark.errorText}
                fullWidth
                inputProps={{ maxLength: 50 }}
              />
            </GridItem>
          </GridContainer>
          <div className="p-mt-4">
            <div className="heading-area">
              <h2>Raw Data</h2>
            </div>
            <hr />
            <div>
              <div className="inward-table p-my-2">
                <DataTable
                  className="main-table table-td"
                  // style={{ width: "calc(100% + 320px)", height: "auto" }}
                  value={rawDataList}
                  key={rawDataList}
                  editMode="row"
                  dataKey="id"
                  responsiveLayout="scroll"
                  emptyMessage="No records found"
                  columnResizeMode="fit"
                  scrollable={true}
                  style={{ maxHeight: 'min(60vh, calc(100vh - 500px))', overflowY: "auto" }}
                >
                  <Column
                    field="Index"
                    header="Sr.No"
                    body={actionBodyTemplateSrNo}
                    style={{ width: "20% !important" }}
                  ></Column>
                  <Column
                    field="Item"
                    header="Items"
                    style={{ width: "20% !important" }}
                    body={(rowData, props) => {
                      if (rowData.ProcessId === "" && !readOnly) {
                        return (
                          <Autocomplete
                            id={"item"}
                            name={"item"}
                            value={
                              rowData.ItemId && itemList.length
                                ? itemList.filter(
                                  (y) => y.value == rowData.ItemId,
                                )[0]
                                : ""
                            }
                            options={itemList}
                            getOptionLabel={(option) =>
                              option.label ? option.label : option
                            }
                            onChange={async (e, value) => {
                              let tempRawData = [...rawDataList];
                              tempRawData[props.rowIndex].ItemId = value?.value;
                              if (value?.value) {
                                let tempItem = itemList.find(
                                  (item) => item.value === value?.value,
                                );
                                tempRawData[props.rowIndex].Item =
                                  tempItem?.label;

                                tempRawData[props.rowIndex].OriginalUnitId =
                                  tempItem?.unitId || "";
                                tempRawData[props.rowIndex].UnitId =
                                  tempItem?.unitId || "";
                                tempRawData[props.rowIndex].Unit = unitList.find(
                                  (unit) => unit.value === tempItem?.unitId,
                                )?.label;
                                if (tempRawData[props.rowIndex].Quantity) {
                                  let responsePrice = await CalculatePriceBasedOnMode(
                                    {
                                      Qty: tempRawData[props.rowIndex].Quantity,
                                      ItemId: value?.value,
                                      UnitId: tempItem?.unitId,
                                      SubWarehouse:
                                        tempRawData[props.rowIndex].SubWarehouse,
                                    },
                                  );
                                  if (responsePrice?.Price) {
                                    tempRawData[props.rowIndex].Cost =
                                      responsePrice?.Price / parseFloat(tempRawData[props.rowIndex].Quantity || 1);
                                  } else {
                                    tempRawData[props.rowIndex].Cost = 0;
                                  }
                                }
                              }
                              setRawDataList(tempRawData);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label="Item"
                                disabled={readOnly}
                              />
                            )}
                          />
                        );
                      } else {
                        return rowData.Item;
                      }
                    }}
                  ></Column>
                  <Column
                    field="Unit"
                    header="Unit"
                    style={{ width: "20% !important" }}
                    body={(rowData, props) => {
                      if (rowData.ProcessId === "" && !readOnly) {
                        return (
                          <Autocomplete
                            id={"unit"}
                            name={"unit"}
                            value={
                              rowData.UnitId && unitList.length
                                ? unitList.filter(
                                  (y) => y.value == rowData.UnitId,
                                )[0]
                                : ""
                            }
                            options={unitList}
                            getOptionLabel={(option) =>
                              option.label ? option.label : option
                            }
                            onChange={async (e, value) => {
                              let tempRawData = [...rawDataList];
                              tempRawData[props.rowIndex].UnitId = value?.value;
                              if (value?.value) {
                                tempRawData[props.rowIndex].Unit = unitList.find(
                                  (unit) => unit.value === value?.value,
                                )?.label;
                                if (
                                  tempRawData[props.rowIndex].ItemId &&
                                  tempRawData[props.rowIndex].Quantity
                                ) {
                                  let responsePrice = await CalculatePriceBasedOnMode(
                                    {
                                      Qty: tempRawData[props.rowIndex].Quantity,
                                      ItemId: tempRawData[props.rowIndex].ItemId,
                                      UnitId: value?.value,
                                      SubWarehouse:
                                        tempRawData[props.rowIndex].SubWarehouse,
                                    },
                                  );
                                  if (responsePrice?.Price) {
                                    tempRawData[props.rowIndex].Cost =
                                      responsePrice?.Price / parseFloat(tempRawData[props.rowIndex].Quantity || 1);
                                  } else {
                                    tempRawData[props.rowIndex].Cost = 0;
                                  }
                                }
                              }
                              setRawDataList(tempRawData);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                label="Item"
                                disabled={readOnly}
                              />
                            )}
                          />
                        );
                      } else {
                        return rowData.Unit;
                      }
                    }}
                  ></Column>
                  <Column
                    field="Quantity"
                    header="Qty"
                    style={{ width: "20% !important" }}
                    body={(rowData, props) => {
                      if (rowData.ProcessId === "" && !readOnly) {
                        return actionBodyData(rowData, props, "Quantity", "Raw");
                      } else {
                        return rowData?.Quantity;
                      }
                    }}
                  ></Column>
                  <Column
                    // field="AvailableQuantity"
                    header="Available Qty"
                    style={{ width: "20% !important" }}
                    body={(rowData) => {
                      return tabValue === 1
                        ? rowData?.AvailableQuantity
                        : getAvailableItemQuantity(
                          rowData.ItemId,
                          rowData.SubWarehouse,
                        );
                    }}
                  ></Column>
                  {(userPageAccess.includes("Inward Cost") && tabValue === 1) ||
                    tabValue === 0 ? (
                    <Column
                      field="Cost"
                      header="Rate"
                      style={{ width: "20% !important" }}
                      body={(rowData, props) =>
                        actionBodyData(rowData, props, "Cost", "Raw")
                      }
                    ></Column>
                  ) : null}
                  {(userPageAccess.includes("Inward Discount") &&
                    tabValue === 1) ||
                    tabValue === 0 ? (
                    <Column
                      field="Discount"
                      header="Discount"
                      style={{ width: "20% !important" }}
                      body={(rowData, props) =>
                        actionBodyData(rowData, props, "Discount", "Raw")
                      }
                    ></Column>
                  ) : null}
                  {(userPageAccess.includes("Inward GST") && tabValue === 1) ||
                    tabValue === 0 ? (
                    <Column
                      field="GST"
                      header="G.S.T"
                      style={{ width: "20% !important" }}
                      body={(rowData, props) =>
                        actionBodyData(rowData, props, "GST", "Raw")
                      }
                    ></Column>
                  ) : null}
                  <Column
                    header="Base Amount"
                    style={{ width: "20% !important" }}
                    body={(rowData) =>
                      (
                        (parseFloat(rowData.Cost) || 0) *
                        (parseFloat(rowData.Quantity) || 0)
                      ).toFixed(2)
                    }
                  ></Column>
                  {(userPageAccess.includes("Inward Price") && tabValue === 1) ||
                    tabValue === 0 ? (
                    <Column
                      field="Price"
                      header="Total Amount"
                      style={{ width: "20% !important" }}
                    ></Column>
                  ) : null}

                  <Column
                    header="Tax Amount"
                    style={{ width: "20% !important" }}
                    body={(rowData) => {
                      let cost = parseFloat(rowData.Cost) || 0;
                      let qty = parseFloat(rowData.Quantity) || 0;
                      let price = parseFloat(rowData.Price) || 0;
                      let discount = parseFloat(rowData.Discount) || 0;
                      let totalAmt = cost * qty;
                      let discountAmt = totalAmt * (discount / 100);
                      return (price - (totalAmt - discountAmt)).toFixed(2);
                    }}
                  ></Column>
                  {!readOnly && (
                    <Column
                      header={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>Action</span>
                        </div>
                      }
                      style={{ width: "20% !important" }}
                      body={(rowData, props) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {rowData.ProcessId === "" && (
                            <i
                              onFocus={(e) =>
                              (e.currentTarget.style.outline =
                                "2px solid #1890ff")
                              }
                              onBlur={(e) =>
                                (e.currentTarget.style.outline = "none")
                              }
                              className="icon-delete cursor-pointer"
                              style={{ width: '32px', height: "32px", textAlign: "center", border: "1px solid red", color: "red", borderRadius: "4px", color: "#ff0000", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}
                              tabIndex={0}
                              role="button"
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  let tempData = [...rawDataList];
                                  tempData = tempData.filter(
                                    (data, index) => index !== props.rowIndex,
                                  );
                                  setRawDataList(tempData);
                                }
                              }}
                              onClick={() => {
                                let tempData = [...rawDataList];
                                tempData = tempData.filter(
                                  (data, index) => index !== props.rowIndex,
                                );
                                setRawDataList(tempData);
                              }}
                            ></i>
                          )}
                          {/* Add Row */}
                          {/* {!readOnly && ( */}
                          <i
                            className="icon-add cursor-pointer ml-2"
                            onFocus={(e) =>
                            (e.currentTarget.style.outline =
                              "2px solid #1890ff")
                            }
                            onBlur={(e) =>
                              (e.currentTarget.style.outline = "none")
                            }
                            tabIndex={0}
                            role="button"
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                handleOpen(e, "AddRawData");
                              }
                            }}
                            onClick={(e) => handleOpen(e, "AddRawData")}
                             style={{ width: '32px', height: "32px", textAlign: "center", marginLeft: "8px", backgroundColor: '#303f9f', color: "#ffffff", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}
                          ></i>
                          {/* )} */}
                        </div>
                      )}
                    ></Column>
                  )}
                  {/* <Column
                  field={getRawDataLabel().Input1.value}
                  header={getRawDataLabel().Input1.label}
                  style={{ width: "20% !important" }}
                  body={(rowData, props) =>
                    actionBodyData(rowData, props, "Dropdown1", "Raw")
                  }
                ></Column>

                <Column
                  field={getRawDataLabel().Input2.value}
                  header={getRawDataLabel().Input2.label}
                  style={{ width: "20% !important" }}
                  body={(rowData, props) =>
                    actionBodyData(rowData, props, "Dropdown2", "Raw")
                  }
                ></Column> */}
                </DataTable>
              </div>
            </div>

            {/* <div className="">
            <div className="p-d-flex p-ai-center p-jc-between e-section-heading">
              <h3>Converted Data</h3>
            </div>
            <div className="inward-table">
              <DataTable
                className="main-table table-td data-table"
                // style={{ width: "calc(100% + 320px)", height: "auto" }}
                value={convertedDataList}
                editMode="row"
                dataKey="id"
                responsiveLayout="scroll"
                emptyMessage="No records found"
                columnResizeMode="fit"
                scrollable={true}
              >
                <Column
                  field="Index"
                  header="Sr.No"
                  body={actionBodyTemplateSrNo}
                  style={{ width: "20% !important" }}
                ></Column>
                <Column
                  field="Item"
                  header="Items"
                  style={{ width: "20% !important" }}
                ></Column>
                <Column
                  field="Unit"
                  header="Unit"
                  style={{ width: "20% !important" }}
                ></Column>
                <Column
                  field="Quantity"
                  header="Qty"
                  style={{ width: "20% !important" }}
                ></Column>
                <Column
                  field="AvailableQuantity"
                  header="Available Qty"
                  style={{ width: "20% !important" }}
                  body={(rowData) => {
                    return getAvailableItemQuantity(
                      rowData.ItemId,
                      rowData.SubWarehouse
                    );
                  }}
                ></Column>
                {(userPageAccess.includes("Outward Cost") && tabValue === 1) ||
                  tabValue === 0 ? (
                  <Column
                    field="Cost"
                    header="Rate"
                    style={{ width: "20% !important" }}
                    body={(rowData, props) =>
                      actionBodyData(rowData, props, "Cost", "Converted")
                    }
                  ></Column>
                ) : null}
                {(userPageAccess.includes("Outward Discount") &&
                  tabValue === 1) ||
                  tabValue === 0 ? (
                  <Column
                    field="Discount"
                    header="Discount"
                    style={{ width: "20% !important" }}
                    body={(rowData, props) =>
                      actionBodyData(rowData, props, "Discount", "Converted")
                    }
                  ></Column>
                ) : null}
                {(userPageAccess.includes("Outward GST") && tabValue === 1) ||
                  tabValue === 0 ? (
                  <Column
                    field="GST"
                    header="G.S.T"
                    style={{ width: "20% !important" }}
                    body={(rowData, props) =>
                      actionBodyData(rowData, props, "GST", "Converted")
                    }
                  ></Column>
                ) : null}
                {(userPageAccess.includes("Outward Price") && tabValue === 1) ||
                  tabValue === 0 ? (
                  <Column
                    field="Price"
                    header="Price"
                    style={{ width: "20% !important" }}
                  ></Column>
                ) : null}

                <Column
                  field={getRawDataLabel().Input1.value}
                  header={getRawDataLabel().Input1.label}
                  style={{ width: "20% !important" }}
                  body={(rowData, props) =>
                    actionBodyData(rowData, props, "Dropdown1", "Converted")
                  }
                ></Column>

                <Column
                  field={getRawDataLabel().Input2.value}
                  header={getRawDataLabel().Input2.label}
                  style={{ width: "20% !important" }}
                  body={(rowData, props) =>
                    actionBodyData(rowData, props, "Dropdown2", "Converted")
                  }
                ></Column>
              </DataTable>
            </div>
          </div> */}
          </div>
        </div>
      </div>
      <div className="e-grand-total">
        Grand Total: {grandTotal}
      </div>

      <Dialog
        open={multiplyProcessDialog}
        onClose={() => handleClose("multiplyProcessDialog")}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Process Multiplication</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("multiplyProcessDialog")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <DataTable
              className="main-table table-td"
              value={tempProcessMultiplyList}
              editMode="row"
              dataKey="id"
              responsiveLayout="scroll"
              emptyMessage="No records found"
              columnResizeMode="fit"
              scrollable={true}
            >
              <Column
                field="Index"
                header="Sr.No"
                body={actionBodyTemplateSrNo}
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="ProcessName"
                header="Process Name"
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="MultiplyBy"
                header="Multiply"
                style={{ width: "20%" }}
                body={actionBodyMultiplyBy}
              ></Column>
            </DataTable>
          </GridContainer>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("multiplyProcessDialog")}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => handleMultiplyProcess(e)}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Vendor Modal */}
      <Dialog
        open={addVendorModal}
        onClose={() => resetVendorModal()}
        aria-labelledby="add-vendor-dialog-title"
      >
        <DialogTitle
          id="add-vendor-dialog-title"
          className="custom-dialog-header"
        >
          <div>Add Vendor</div>
          <div className="dialog-close" onClick={() => resetVendorModal()}>
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <TextField
                autoFocus
                margin="dense"
                label="First Name"
                type="text"
                value={vendorFirstName}
                onChange={(e) => setVendorFirstName(e.target.value)}
                fullWidth
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                label="Last Name"
                type="text"
                value={vendorLastName}
                onChange={(e) => setVendorLastName(e.target.value)}
                fullWidth
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                label="Company Name *"
                type="text"
                value={vendorCompanyName}
                onChange={(e) => setVendorCompanyName(e.target.value)}
                fullWidth
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                label="Phone No"
                type="text"
                value={vendorPhone}
                onChange={(e) => setVendorPhone(e.target.value)}
                fullWidth
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                label="Email"
                type="email"
                value={vendorEmail}
                onChange={(e) => setVendorEmail(e.target.value)}
                fullWidth
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                label="Address"
                type="text"
                value={vendorAddress}
                onChange={(e) => setVendorAddress(e.target.value)}
                fullWidth
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <div className="input-control select p-d-flex p-mt-2">
                <FormControl fullWidth>
                  <MultiSelect
                    value={vendorUserType}
                    onChange={(e) => setVendorUserType(e.value)}
                    options={vendorUserTypeList}
                    optionLabel="label"
                    placeholder="Select User Type *"
                    className="p-w-100"
                  />
                </FormControl>
              </div>
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button className="primary-btn1" onClick={() => resetVendorModal()}>
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={() => addVendorHandler()}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddInwardStock;
